import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [{
    name: 'home',
    url: '/',
    component: 'wtHomeState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve
    },
    data: {
        visible: true, // visible in the left menu
        isMobileVisible: true,
        sortingOrder: 1,
        icon: 'fa-home', // font awesome's icon 
        displayName: 'Home', // the text displayed in the menu, tooltip and breadcrumb
        ignoreHistory: true,
        //hotkey: 'ctrl+alt+h', // shortcut to hotkey
        editButtonVisibility: () => false,
        subMenu: {
            displayName: 'History'
        }
    }
}];

export default states;